import { createContext, useContext } from 'react';

// Accepts any graph reducer action — typed loosely to avoid coupling to the full action union.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type GraphDispatchFn = (action: any) => void;

export const GraphDispatchContext = createContext<GraphDispatchFn | null>(null);

export const GraphDispatchContextProvider = GraphDispatchContext.Provider;

export function useGraphDispatch() {
    return useContext(GraphDispatchContext);
}
